import { Calendar, CalendarProps } from '@/components/ui/calendar';
import { usePeriodClosureContext } from '@/context/PeriodClosureContext';
import { Matcher } from 'react-day-picker';

type PeriodClosureCalendarProps = CalendarProps & {
  disableClosedPeriod?: boolean;
};

const PeriodClosureCalendar = ({
  disabled,
  disableClosedPeriod = true,
  ...props
}: PeriodClosureCalendarProps) => {
  const { isDateInClosedPeriod } = usePeriodClosureContext();

  const closedPeriodMatcher: Matcher = (date: Date) => isDateInClosedPeriod(date);

  const getDisabled = (): Matcher | Matcher[] | undefined => {
    if (!disableClosedPeriod) {
      return disabled;
    }
    if (!disabled) {
      return closedPeriodMatcher;
    }
    if (Array.isArray(disabled)) {
      return [...disabled, closedPeriodMatcher];
    }
    return [disabled, closedPeriodMatcher];
  };

  return <Calendar disabled={getDisabled()} {...props} />;
};

export default PeriodClosureCalendar;
